import { IconCopy, IconPlus } from "@tabler/icons-react";

import { Flex } from "../../styled";
import RowActionButton from "../_Buttons/RowActionButton/RowActionButton";
import useAddDynamicRow from "../hooks/useAddDynamicRow";

interface Props {
  sectionIndex: number;
  copyPrevVal: number | undefined;
  subSectionIndex: number;
  cloneRows?: boolean;
}
const AddDynamicRow = ({
  sectionIndex,
  copyPrevVal,
  subSectionIndex,
  cloneRows,
}: Props) => {
  const { addLandscapeRow } = useAddDynamicRow({
    copyPrevVal,
    subSectionIndex,
  });
  return (
    <Flex direction="column" gap={10}>
      <RowActionButton
        icon={<IconPlus size="1.5rem" />}
        mt={0}
        onClick={() => addLandscapeRow(sectionIndex)}>
        Add Row
      </RowActionButton>
      {cloneRows && (
        <RowActionButton
          icon={<IconCopy size="1.5rem" />}
          mt={0}
          onClick={() => addLandscapeRow(sectionIndex, true)}>
          Copy
        </RowActionButton>
      )}
    </Flex>
  );
};

export default AddDynamicRow;
